
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateMeetingDecisionDtoFormGroup() {
return new FormGroup({
    description: new FormControl<string | undefined>(''),
    decidedAt: new FormControl<string | undefined>(''),
})
;
}
      